import React from 'react'
import { callAllHandlers } from '@mote/helpers/assertion'
import { __DEV__ } from '@mote/helpers/constants'
import { mergeClassnames } from '@mote/helpers/dom'
import { forwardRef } from '../../system'
import type { CloseButtonProps } from '../closeButton'
import { CloseButton } from '../closeButton'
import { useDialogContext } from './DialogProvider'

export interface DialogCloseButtonProps extends CloseButtonProps {
  placement?: 'right' | 'left'
}

export const DialogCloseButton = forwardRef<DialogCloseButtonProps, 'button'>(
  (props, ref) => {
    const { className, onClick, placement, ...rest } = props
    const { onClose } = useDialogContext()

    const _className = mergeClassnames('mote-dialog__close-button', className)

    return (
      <CloseButton
        ref={ref}
        size={32}
        className={_className}
        position='absolute'
        top='8px'
        onClick={callAllHandlers(onClick, (event: React.MouseEvent) => {
          event.stopPropagation()
          onClose('button')
        })}
        {...(placement === 'left' ? { left: '8px' } : { right: '8px' })}
        {...rest}
      />
    )
  }
)

if (__DEV__) {
  DialogCloseButton.displayName = 'DialogCloseButton'
}
